import { colors } from '../../Colors/colors'

export const paymentRequests = {
   light: {
      paymentRequestModal: {
         headingColor: 'text-gray-900',
         defaultBgColor: 'bg-base-white',
         amountDescriptionColor: 'text-gray-500',
         upiModeLabelColor: 'text-gray-600',
         footerAmountColor: 'text-gray-800',
         lineColor: 'bg-gray-300',
         marketValueLabelColor: 'text-gray-700',
         backgroundColor: 'bg-gray-100',
         customHeadAddingBgColor: 'bg-white',
         recalculateBorderColor: '!border-primary-600',
         ruleSetNameColor: 'text-gray-700',
         skeletonColor: '#F6F7F9',
         skeletonBgColor: colors['gray-200']
      },
      paymentRequestTab: {
         plusIconColor: colors['base-white'],
         requestTableBgColor: 'bg-base-white',
         borderColor: 'border-gray-300'
      }
   },
   dark: {}
}
